import type { ProfileFields } from './profile';

export const USER_PROFILE_FIELDS: ProfileFields[] = [
  'academicMetrics',
  'academicApTests',
  'academicEntranceExams',
  'academicExtracurricularInvolvement',
  'academicRigor',
  'academicDegrees',
  'academicEnrollmentTypes',
  'academicsHighSchoolCurrentEnrollment',
  'academicsPostSecondaryCurrentEnrollment',
  'academicsAlmaMaters',
  'academicMajors',
  'academicHighSchoolExpectedGraduationYear',
  'academicPostSecondaryExpectedGraduationYear',
  'academicEducationalExperiences',

  'careerExperiences',
  'careerOccupation',
  'careerEmployer',
  'careerPaths',

  'demographicsGenders',
  'demographicsEthnicities',
  'demographicsReligions',
  'demographicsAffinities',
  'demographicsRelationshipExperiences',
  'demographicsFamilyRoles',
  'demographicsChildhoodExperiences',
  'demographicsMyersBriggs',
  'demographicsHigh5s',
  'demographicsStrengthsFinders',
  'demographicsAstrologySigns',

  'financialExperiences',
  'financialCredentials',
  'financialProfile',
  'financialFamilyIncomes',

  'healthMentalHealthInterests',
  'healthInterests',
  'healthFoodNutrition',
  'healthExperiences',

  'hobbiesCreativeInterests',
  'hobbiesPassions',
  'hobbiesFavorites',

  'resourcesClubs',
  'resourcesLanguages',

  'documentsResumes',
  'documentsTranscripts',
  'documentsPersonalAssessment',
  'documentsStoryVideos',
  'documentsPurposeVideo',

  'linkedInData',

  'publicProfile',
];
